<template>
	<div>
		<div style="position:relative;overflow: hidden;">
			<div
				class="ui segment"
				style="position:absolute;right: 0;z-index: 1001;min-width: 300px;height: 100%;border-top-left-radius: 0;border-bottom-left-radius: 0; overflow:auto;"
				:class="{ [$style.displaynone]: !mostrar, [$style.segmentadd]: true }"
				:style="{ width: anchoDetalle }"
			>
				<h4 class="ui header" :class="$style.headeradd">
					<slot name="TITLE_ITEM"></slot>
				</h4>
				<i class="ellipsis vertical icon" :class="$style.iconmore"></i>
				<i class="fitted icon close" :class="$style.iconclose" @click="mostrar = false"></i>
				<slot name="BODY_ITEM" :item="elemento" class="boldFont greyColor"></slot>
			</div>
			<SuiDimmer :active="mostrar" inverted @click="mostrar = false" />
			<table
				class="ui table celled sortable"
				:class="{ [tipo]: true }"
				style="min-height:600px;margin: 0 0;"
			>
				<thead>
					<tr>
						<template v-for="(campo, key) in campos">
							<slot :name="`HEAD_${key}`" :campo="campo">
								<th
									:key="key"
									:colspan="(actions && key === nombreDelUltimoCampo) ? 2 : 1"
									class="boldFont greyColor"
									:class="{
										[campo.class]: camposPorObjeto,
										sorted:
											camposPorObjeto && !campo.noSort && key === ordenadoPor,
										ascending: camposPorObjeto && ordenadoPorTipo === 'asc',
										descending: camposPorObjeto && ordenadoPorTipo === 'desc'
									}"
									@click="onClickSort(key, ordenadoPorTipo)"
								>
									<b class="boldFont greyColor">
										{{
										camposPorObjeto ? campo.nombre : campo
										}}
									</b>
								</th>
							</slot>
						</template>
					</tr>
				</thead>
				<tbody>
					<template
						v-if="
							!loading &&
								(elementos.length === 0 || elementosFiltrados.length === 0)
						"
					>
						<tr>
							<td :colspan="Object.keys(campos).length + 1">
								<div class="ui" style="position:relative;text-align:center;">
									<slot v-if="elementos.length === 0" name="EMPTY">Sin registros para mostrar</slot>
									<slot
										v-if="
											elementosFiltrados.length === 0 && elementos.length > 0
										"
										name="EMPTY_FILTER"
									>Sin registros para mostrar</slot>
								</div>
							</td>
						</tr>
						<tr v-for="blanco in (0, elementosBlancos)" :key="`BLANCO-${blanco}`">
							<td :colspan="Object.keys(campos).length + 1">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
						</tr>
					</template>
					<template v-if="!loading">
						<tr
							v-for="(element, index) in elementosMostrar"
							:key="index"
							:class="{ [$style.onhoverrow]: !sinDetalle }"
							@click="onSeleccionarElemento(element)"
							@mouseover="elementoEnOver = element"
						>
							<td
								v-for="(campo, key) in camposTabla"
								:key="`${index}-${key}`"
								:colspan="(actions && key === nombreDelUltimoCampo) ? getColspanAction(element) : 1"
							>
								<slot :name="key" :item="element">{{ element[key] }}</slot>
							</td>
							<td v-if="actions" :class="$style.transparente" style="border-left: none !important;">
								<slot name="action" :item="element"></slot>
							</td>
						</tr>
					</template>
					<template
						v-if="
							!loading &&
								elementos.length !== 0 &&
								elementosFiltrados.length !== 0
						"
					>
						<tr v-for="blanco in (0, elementosBlancos)" :key="`BLANCO-${blanco}`">
							<td
								v-for="(campo, key) in camposTabla"
								:key="`${blanco}-BLANCO-${key}`"
								:colspan="(actions && key === nombreDelUltimoCampo ) ? 2 : 1"
							>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
						</tr>
					</template>
					<tr v-if="loading">
						<td :colspan="Object.keys(campos).length + 1">
							<div class="ui" style="position:relative;height: 600px;">
								<div style="z-index: 0;" class="ui inverted active dimmer">
									<div class="ui centered inline loader text">Cargando</div>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<br />
		<div v-if="paginas > 1" class="ui right floated mini pagination menu">
			<a
				class="ui icon item active"
				:class="{ disabled: paginaActual <= 1 }"
				@click="cambiarPagina(1, paginaActual <= 1)"
			>
				<i class="left angle double icon"></i>
			</a>
			<a
				class="ui icon item active"
				:class="{ disabled: paginaActual <= 1 }"
				@click="cambiarPagina(paginaActual - 1, paginaActual <= 1)"
			>
				<i class="left angle icon"></i>
			</a>
			<a
				v-for="numero in rangoPaginasMostrar"
				:key="numero"
				class="ui item"
				:class="{ disabled: numero === paginaActual }"
				@click="
					cambiarPagina(
						numero,
						numero === paginas && paginas !== paginasMostrar
					)
				"
			>{{ numero }}</a>
			<a
				class="ui icon item active"
				:class="{ disabled: paginaActual >= paginas }"
				@click="cambiarPagina(paginaActual + 1, paginaActual >= paginas)"
			>
				<i class="right angle icon"></i>
			</a>
			<a
				class="ui icon item active"
				:class="{ disabled: paginaActual >= paginas }"
				@click="cambiarPagina(paginas, paginaActual >= paginas)"
			>
				<i class="right angle double icon"></i>
			</a>
		</div>
	</div>
</template>
<script>
export default {
	inheritAttrs: false,
	props: {
		tipo: {
			type: String,
			default: 'compact'
		},
		campos: {
			type: Object,
			default: () => ({})
		},
		elementos: {
			type: Array,
			default: () => []
		},
		porPagina: {
			type: Number,
			default: 13
		},
		paginaActual: {
			type: Number,
			default: 1
		},
		loading: {
			type: Boolean,
			default: false
		},
		elemento: {
			type: Object,
			default: null
		},
		onSeleccionar: {
			type: Function,
			default: null
		},
		filtro: {
			type: [String, Function],
			default: null
		},
		bloquesMostrar: {
			type: Number,
			default: 5
		},
		ordenarPor: {
			type: String,
			default: ''
		},
		tipoOrden: {
			type: String,
			default: 'desc'
		},
		sinDetalle: {
			type: Boolean,
			default: false
		},
		actions: {
			type: Boolean,
			default: false
		},
		anchoDetalle: {
			type: String,
			default: '40%'
		}
	},
	data: function() {
		return {
			mostrar: false,
			tipoOrdenLocal: 'desc',
			ordenarPorLocal: '',
			elementoEnOver: {}
		};
	},
	computed: {
		camposTabla: function() {
			const campos = {};
			for (var key in this.campos) {
				const campo = this.campos[key];
				campos[key] = typeof campo === 'object' ? campo.nombre : campo;
			}
			return campos;
		},
		ordenadoPorTipo: function() {
			return this.ordenarPor ? this.tipoOrden : this.tipoOrdenLocal;
		},
		ordenadoPor: function() {
			if (!this.ordenarPor && !this.ordenarPorLocal) {
				/* eslint-disable vue/no-side-effects-in-computed-properties */
				this.ordenarPorLocal = this.nombreDelPrimerCampo;
				/* eslint-enable vue/no-side-effects-in-computed-properties */
			}
			return this.ordenarPor ? this.ordenarPor : this.ordenarPorLocal;
		},
		nombreDelPrimerCampo() {
			for (var key in this.campos) {
				if (this.camposPorObjeto && !this.campos[key].noSort) {
					return key;
				} else {
					return key;
				}
			}
			return '';
		},
		camposPorObjeto: function() {
			let esPorObjeto = false;
			for (var key in this.campos) {
				if (typeof this.campos[key] === 'object') {
					esPorObjeto = true;
					break;
				}
			}
			return esPorObjeto;
		},
		elementosOrdenados: function() {
			const elementos = [...this.elementos];
			if (this.ordenadoPor) {
				return elementos.sort((a, b) => {
					let modifier = 1;
					if (this.ordenadoPorTipo === 'desc') modifier = -1;
					if (a[this.ordenadoPor] < b[this.ordenadoPor]) return -1 * modifier;
					if (a[this.ordenadoPor] > b[this.ordenadoPor]) return 1 * modifier;
					return 0;
				});
			}
			return elementos;
		},
		elementosFiltrados: function() {
			if (!this.filtro) return this.elementosOrdenados;
			if (typeof this.filtro === 'function')
				return this.elementosOrdenados.filter(this.filtro);
			return this.elementosOrdenados.filter((elemento) => {
				let tieneElemento = false;
				for (var campo in this.camposTabla) {
					if (
						elemento[campo] &&
						elemento[campo]
							.toString()
							.toUpperCase()
							.indexOf(this.filtro.toString().toUpperCase()) >= 0
					)
						tieneElemento = true;
				}
				return tieneElemento;
			});
		},
		elementosMostrar: function() {
			return this.elementosFiltrados.slice(this.startIndex, this.endIndex);
		},
		endIndex: function() {
			const totalMuestra =
				this.totalElementos - this.startIndex + this.porPagina;
			return (
				this.startIndex + (totalMuestra > 0 ? this.porPagina : totalMuestra)
			);
		},
		startIndex: function() {
			return this.porPagina * (this.paginaActual - 1);
		},
		paginas: function() {
			const paginas = Math.ceil(this.totalElementos / this.porPagina);
			return Number(paginas !== 0 ? paginas : 1);
		},
		totalElementos: function() {
			return Number(this.elementosFiltrados.length);
		},
		paginaEmpiezaBloque() {
			const diferencia = this.paginaActual - parseInt(this.bloquesMostrar / 2);
			return diferencia > 0 ? diferencia : 1;
		},
		paginasMostrar: function() {
			const paginasMostrarSinLimite =
				this.paginaEmpiezaBloque + this.bloquesMostrar;
			return paginasMostrarSinLimite < this.paginas
				? paginasMostrarSinLimite
				: this.paginas;
		},
		rangoPaginasMostrar: function() {
			return [
				...Array(this.paginasMostrar - this.paginaEmpiezaBloque + 1).keys()
			].map((i) => i + this.paginaEmpiezaBloque);
		},
		elementosBlancos() {
			const blancos = this.porPagina - this.elementosMostrar.length;
			return this.elementosMostrar.length === 0 ? blancos - 1 : blancos;
		},
		nombreDelUltimoCampo() {
			var keys = Object.keys(this.campos);
			if (keys.length > 0) {
				return keys[keys.length - 1];
			}
			return '';
		}
	},
	watch: {
		filtro: function(value) {
			if (this.mostrar) this.mostrar = false;
		}
	},
	methods: {
		cambiarPagina: function(pagina, disabled) {
			if (!disabled) {
				if (this.mostrar) this.mostrar = false;
				this.$emit('cambiarPagina', pagina);
			}
		},
		onSeleccionarElemento(elemento) {
			this.$emit('onSeleccionar', elemento);
		},
		mostrarElemento: function() {
			this.mostrar = true;
		},
		ocultarElemento: function() {
			this.mostrar = false;
		},
		onClickSort: function(key, tipoOrdenAnterior) {
			if (this.ordenarPorLocal === key) {
				if (tipoOrdenAnterior === 'desc') {
					this.tipoOrdenLocal = 'asc';
				} else {
					this.tipoOrdenLocal = 'desc';
					this.$emit('onClickSort', key, this.tipoOrdenLocal);
				}
			} else {
				this.ordenarPorLocal = key;
				this.tipoOrdenLocal = 'desc';
			}
			this.$emit('onClickSort', this.ordenarPorLocal, this.tipoOrdenLocal);
		},
		onCallbackAction(element, callback) {
			this.$emit(callback, element);
		},
		getColspanAction(element) {
			return this.elementoEnOver === element ? 1 : 2;
		}
	}
};
</script>
<style lang="scss" module>
@import '@design';
.onhoverrow {
	cursor: pointer;
}
.segmentadd {
	-webkit-tap-highlight-color: transparent;
	-webkit-transition: all 0.3s ease;
	-moz-transition: all 0.3s ease;
	-o-transition: all 0.3s ease;
	-ms-transition: all 0.3s ease;
	transition: all 0.3s ease;
}

.iconclose {
	position: absolute;
	top: 1rem;
	right: 1rem;
	margin: 0;
	font-size: 20px;
	color: #000;
	cursor: pointer;
	opacity: 0.5;
	-webkit-transition: opacity 0.3s ease-out;
	-moz-transition: opacity 0.3s ease-out;
	-o-transition: opacity 0.3s ease-out;
	-ms-transition: opacity 0.3s ease-out;
	transition: opacity 0.3s ease-out;
}

.iconmore {
	position: absolute;
	top: 1rem;
	left: 1rem;
	margin: 0;
	font-size: 20px;
	color: #000;
	cursor: pointer;
	opacity: 0.5;
	-webkit-transition: opacity 0.3s ease-out;
	-moz-transition: opacity 0.3s ease-out;
	-o-transition: opacity 0.3s ease-out;
	-ms-transition: opacity 0.3s ease-out;
	transition: opacity 0.3s ease-out;
}

.headeradd {
	margin-left: 1.3em !important;
	font-size: 18px !important;
}

.transparente {
	display: none;
}

tr:hover .transparente {
	display: table-cell !important;
}

.displaynone {
	right: -100% !important;
}
</style>
